import "./PersonalInfo.scss";

export default function PersonalInfo({
  userData,
  personalInfo,
  performanceInfo,
  Total,
  servecis1,
  servecis2
}) {
  return (
    <div className="personal-info mb-3">
      <div className="d-flex align-items-center gap-5 flex-wrap">
        <div>
          <div className="image mb-4">
            {userData.image || "Image"}
          </div>
          <div className="d-flex align-items-center gap-2">
            <div
              style={{
                backgroundColor: userData.online ? "#0ec755" : "gray",
                width: "10px",
                height: "10px",
                borderRadius: "50px",
              }}
            ></div>
            <span style={{ color: "#b6bfe8" }}>
              {userData.online ? "Online" : "Offline"}
            </span>
          </div>
        </div>

        <div className="d-flex flex-column">
          <h4
            style={{
              color: "black",
              marginBottom: "15px",
              fontSize: "20px",
            }}
          >
            {userData.name}
          </h4>
          <span
            style={{
              color: "#858993",
              fontSize: "15px",
              marginLeft: "15px",
            }}
          >
            {userData.email}
          </span>
          <span style={{ marginLeft: "15px" }}>{userData.role}</span>
        </div>
      </div>

      <div className="vrt-line"></div>

      <div className="personal-info-box">
        <p className="section-title">Personal Information</p>
        <div className="info-list">
          {Object.entries(personalInfo).map(([label, value]) => (
            <div className="info-item" key={label}>
              <span className="label">{label}</span>
              <span className="value">{value}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="vrt-line"></div>

      <div className="personal-info-box d-flex flex-column justify-content-around">
        <div>
          <p className="section-title">Performance information</p>
          <div>
            <span
              style={{
                color: "#1d4ed8",
                fontWeight: "bold",
                fontSize: "10px",

              }}
            >
              Wallet
            </span>{" "}
            <span
              style={{
                color: "#1d4ed8",
                fontWeight: "bold",
                fontSize: "18px",
              }}
            >
              {performanceInfo.wallet}
            </span>
          </div>
        </div>

        <div className="d-flex gap-5 flex-wrap">
          <div className="d-flex flex-column">
            <span style={{ color: "#01a9fc", fontWeight: "bold" }}>
              {performanceInfo.totalOrders}
            </span>
            <span style={{ color: "#7f838c" }}>Total {Total}</span>
          </div>
          <div className="d-flex flex-column">
            <span style={{ color: "#28c76f", fontWeight: "bold" }}>
              {performanceInfo.balance}
            </span>
            <span style={{ color: "#7f838c" }}>
            {servecis1}
            </span>
          </div>
          <div className="d-flex flex-column">
            <span style={{ color: "#e71d36", fontWeight: "bold" }}>
              {performanceInfo.totalPoints}
            </span>
            <span style={{ color: "#7f838c" }}>  {servecis2}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
